define('GameDayCore/GDControl/SubscriptionManager/SubscriptionManager',['require','exports','module','../../GDModel/enums/datasources/Datasources','extant/extant','../../GDUtil/window/Logg'],function(require,exports,module) {
    var Datasources = require("../../GDModel/enums/datasources/Datasources"),
        exists = require("extant/extant"),
        logg = require("../../GDUtil/window/Logg"),
        subsHash = establishInitSubscribes(),
        initialized = false;


    function establishInitSubscribes() {
        var subs = { },
            sources = Datasources,
            src,
            prop;

        for (prop in sources) {
            src = sources[prop];
            if (src.length > 0) {
                subs[src] = 0;
            }
        }

        return subs;
    }

    function changeSubscription(srcs, addMe) {
        if (addMe && !exists(srcs) && initialized) {
            logg.log("buckshot style subscription is only available at instantiation...");
            return;
        }

        srcs = normalizeSources(srcs);
        for (var i = 0, len = srcs.length, src, subcount; i < len; i++) {
            src = srcs[i];
            if (subsHash.hasOwnProperty(src)) {
                subcount=subsHash[src];
                subsHash[src] += ((addMe) ? 1 : subcount===0 ? 0 : -1);
            }
        }

        if (!initialized) { initialized = true;  }
    }

    function normalizeSources(srcs) {
        var newSrcs = [];
        if (!exists(srcs) || srcs.length === 0) {
            var fullList = Datasources;
            srcs = [];
            for (var prop in fullList) {
                if (typeof fullList[prop] === "string") {
                    srcs.push(fullList[prop]);
                }
            }
        } else if (typeof srcs === "string" && srcs.indexOf(",") >= 0) {
            srcs = srcs.split(",");
        }

        if (srcs.length > 0) {
            newSrcs = [].concat(srcs);
        } else if (typeof srcs === "object") {

            for (var prop in srcs) {
                newSrcs.push(srcs[prop]);
            }
        }

        return newSrcs;
    }

    exports.subscribe = function($srcs) { changeSubscription($srcs, true); };
    exports.unsubscribe = function($srcs) { changeSubscription($srcs, false); };
    exports.checkSubscription = function($src) { return (subsHash[$src] > 0); };
    exports.getSubscriptions = function(){
        var subs = [];
        for (var prop in subsHash) {
            if (subsHash[prop] > 0) {
                subs.push(prop);
            }
        }

        return subs;
    };
});

